import { OnScreenModal } from '@/components/ui/OnScreenModal'
import { ApiLogDetailContent } from './ApiLogDetailContent'

export function ApiLogDetailModal({
  isOpen,
  logId,
  onClose,
}: {
  isOpen: boolean
  logId: string | null
  onClose: () => void
}) {
  return (
    <OnScreenModal
      isOpen={isOpen && Boolean(logId)}
      title="API Log Detail"
      onClose={onClose}
      maxWidth="max-w-900"
      bodyScrollOnly
      overlayDataTestId="api-log-detail-modal"
      panelDataTestId="api-log-detail-modal-panel"
      closeButtonDataTestId="api-log-detail-modal-close"
    >
      {logId ? <ApiLogDetailContent logId={logId} linkApplication={false} framed={false} /> : null}
    </OnScreenModal>
  )
}
